export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const NOTIFICATION_API_CALL = 'NOTIFICATION_API_CALL';
export const SELECTED_COMPANY_DATA = 'SELECTED_COMPANY_DATA';
export const HAS_ANY_PENDING_POLLS = 'HAS_ANY_PENDING_POLLS';
export const CLEAR_DATA = 'CLEAR_DATA';
